import React from 'react';

import ViewStatistics from 'scenes/Dialog/components/ViewStatistics';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import UpgradeCandidateAccount from 'scenes/Dialog/components/UpgradeCandidateAccount';
import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { useApi } from 'hooks/useApi';
import { UPGRADE_ACCOUNT_TYPE } from 'constants/upgrade-account-types';
import { REASON } from 'constants/reasons';
import { ENDPOINT } from 'constants/endpoints';

const TYPE = {
  JOB: 'Job',
  PROJECT: 'Project',
  SHORTLIST: 'Shortlist',
};

const withViewStatisticsAction = WrappedComponent => props => {
  const suppProps = { ...props };
  const { get } = useApi();

  const viewStatistic = (id, endpoint, type) => {
    return new Promise(resolve => {
      get(
        endpoint,
        { id },
        {
          handleError: response => {
            if (
              response.data &&
              response.data.reason &&
              response.data.reason === REASON.INSUFFICIENT_CANDIDATE_LEVEL
            ) {
              if (
                UPGRADE_ACCOUNT_TYPE.RECRUITER === props.user.accountUpgradeType
              ) {
                UpgradeRecruiterAccount();
              } else {
                UpgradeCandidateAccount({ history: props.history });
              }
            } else {
              ResponseErrorDialog({ response });
            }
          },
          handleSuccess: statistics =>
            ViewStatistics({
              data: statistics,
              title: `${type} Statistics`,
            }),
          handleComplete: resolve,
        }
      );
    });
  };

  suppProps.viewStatisticsJob = id => {
    return viewStatistic(id, ENDPOINT.ACTION.VIEW_STATISTICS.JOB, TYPE.JOB);
  };

  suppProps.viewStatisticsJobExtended = id => {
    return viewStatistic(
      id,
      ENDPOINT.ACTION.VIEW_STATISTICS.JOB_EXTENDED,
      TYPE.JOB
    );
  };

  suppProps.viewStatisticsProject = id => {
    return viewStatistic(
      id,
      ENDPOINT.ACTION.VIEW_STATISTICS.PROJECT,
      TYPE.PROJECT
    );
  };

  suppProps.viewStatisticsProjectExtended = id => {
    return viewStatistic(
      id,
      ENDPOINT.ACTION.VIEW_STATISTICS.PROJECT_EXTENDED,
      TYPE.PROJECT
    );
  };

  suppProps.viewStatisticsShortlist = id => {
    return viewStatistic(
      id,
      ENDPOINT.ACTION.VIEW_STATISTICS.SHORTLIST,
      TYPE.SHORTLIST
    );
  };
  return <WrappedComponent {...suppProps} />;
};

export default withViewStatisticsAction;
